/**
 * Component: TopTransactionsCityTable
 * Table placeholder for top transactions per city.
 */

import { ExternalIcon } from "@/assets/svg";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from "@/components/ui/table/table";
import type { CityTransactionData } from "../../../../domain/model/DashboardModel";

export interface TopTransactionsCityTableProps {
  data: CityTransactionData[];
}

export const TopTransactionsCityTable = ({ data }: TopTransactionsCityTableProps): React.JSX.Element => {
  if (data.length === 0) {
    return (
      <div className="bg-white border border-[#e4e6eb] rounded-lg p-4 flex flex-col">
        <div className="flex justify-between items-center mb-3">
          <h3 className="m-0 text-slate-900 font-bold text-base leading-6">Top 5 Redeemed Point per City</h3>
        </div>
        <div className="flex items-center justify-center h-[200px] text-gray-500">
          No city data available
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white border border-[#e4e6eb] rounded-lg p-4 flex flex-col">
      <div className="flex justify-between items-center mb-3">
        <h3 className="m-0 text-slate-900 font-bold text-base leading-6">Top 5 Redeemed Point per City</h3>
        <button
          className="bg-transparent border-none p-0 cursor-pointer flex items-center justify-center hover:opacity-80 focus:outline-none active:opacity-60"
          aria-label="Open external link"
        >
          <ExternalIcon />
        </button>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>City</TableHead>
            <TableHead className="text-right">Redeemed Points</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.city}>
              <TableCell className="!py-3.5 !px-4 !font-normal">{row.city}</TableCell>
              <TableCell className="text-right !py-3.5 !px-4">
                <span className="font-bold">
                  {`${row.totalTransaction.toLocaleString("id-ID")} points`}
                </span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
